import { Observable } from "rxjs/internal/Observable";
import { getApiErrorFactory } from "./factory";

export const apiCatch = (err: any) => {
    const apiError = getApiErrorFactory().getApiError(err)
    return new Observable((observer) => {
        observer.error(apiError);
        observer.complete();
    });
}
